// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";
import * as PhoneNumberPaymentInput$OrcaPaymentPage from "../Components/PhoneNumberPaymentInput.bs.js";

function getPaymentMethodsFieldsOrder(paymentMethodField) {
  if (typeof paymentMethodField !== "object") {
    switch (paymentMethodField) {
      case "InfoElement" :
        return 99;
      case "AddressLine1" :
        return 4;
      case "AddressLine2" :
        return 5;
      case "AddressCity" :
        return 6;
      case "StateAndCity" :
      case "AddressState" :
        return 7;
      case "CardNumber" :
        return 0;
      case "CardExpiryMonth" :
      case "CardExpiryYear" :
      case "CardExpiryMonthAndYear" :
        return 1;
      case "CardCvc" :
      case "CardExpiryAndCvc" :
        return 2;
      case "PixKey" :
        return 8;
      case "AddressPincode" :
      case "PixCPF" :
        return 9;
      case "CryptoCurrencyNetworks" :
      case "PixCNPJ" :
        return 10;
      default:
        return 3;
    }
  } else {
    switch (paymentMethodField.TAG) {
      case "CountryAndPincode" :
      case "AddressCountry" :
        return 8;
      default:
        return 3;
    }
  }
}

function sortPaymentMethodFields(firstPaymentMethodField, secondPaymentMethodField) {
  return getPaymentMethodsFieldsOrder(firstPaymentMethodField) - getPaymentMethodsFieldsOrder(secondPaymentMethodField) | 0;
}

function getCustomerAcceptanceSupport(dict, str) {
  let match = Utils$OrcaPaymentPage.getString(dict, str, "");
  switch (match) {
    case "partially_supported" :
      return "PartiallySupported";
    case "supported" :
      return "Supported";
    case "unsupported" :
      return "Unsupported";
    default:
      return;
  }
}

let defaultPaymentFieldsInfo_fields = [];

let defaultPaymentFieldsInfo = {
  paymentMethodName: "",
  fields: defaultPaymentFieldsInfo_fields,
  icon: undefined,
  displayName: "",
  miniIcon: undefined
};

let defaultPaymentMethodContent_paymentFlow = [];

let defaultPaymentMethodContent_bankNames = [];

let defaultPaymentMethodContent = {
  paymentMethodName: "",
  paymentFlow: defaultPaymentMethodContent_paymentFlow,
  handleUserError: false,
  methodType: "",
  bankNames: defaultPaymentMethodContent_bankNames,
  customerAcceptanceSupport: undefined
};

let defaultPaymentMethodFields_fields = [];

let defaultPaymentMethodFields = {
  paymentMethodName: "",
  fields: defaultPaymentMethodFields_fields,
  icon: undefined,
  displayName: "",
  miniIcon: undefined
};

function icon(sizeOpt, widthOpt, name) {
  let size = sizeOpt !== undefined ? sizeOpt : 22;
  let width = widthOpt !== undefined ? widthOpt : size;
  return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
    name: name,
    size: size,
    width: width
  });
}

function getPaymentMethodsFields(localeString) {
  return [
    {
      paymentMethodName: "afterpay_clearpay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "afterpay"),
      displayName: localeString.payment_methods_afterpay_clearpay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "google_pay",
      fields: ["InfoElement"],
      icon: icon(19, 25, "google_pay"),
      displayName: localeString.payment_methods_google_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "apple_pay",
      fields: ["InfoElement"],
      icon: icon(19, 25, "apple_pay"),
      displayName: localeString.payment_methods_apple_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "mb_way",
      fields: [
        {
          TAG: "SpecialField",
          _0: JsxRuntime.jsx(PhoneNumberPaymentInput$OrcaPaymentPage.make, {})
        },
        "InfoElement"
      ],
      icon: icon(19, undefined, "mbway"),
      displayName: localeString.payment_methods_mb_way,
      miniIcon: undefined
    },
    {
      paymentMethodName: "mobile_pay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "mobilepay"),
      displayName: localeString.payment_methods_mobile_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ali_pay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "alipay"),
      displayName: localeString.payment_methods_ali_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ali_pay_hk",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "alipayhk"),
      displayName: localeString.payment_methods_ali_pay_hk,
      miniIcon: undefined
    },
    {
      paymentMethodName: "we_chat_pay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "wechatpay"),
      displayName: localeString.payment_methods_we_chat_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "duit_now",
      fields: ["InfoElement"],
      icon: icon(20, undefined, "duitNow"),
      displayName: localeString.payment_methods_duit_now,
      miniIcon: undefined
    },
    {
      paymentMethodName: "revolut_pay",
      fields: ["InfoElement"],
      icon: icon(20, undefined, "revolut"),
      displayName: localeString.payment_methods_revolut_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "affirm",
      fields: ["InfoElement"],
      icon: icon(20, undefined, "affirm"),
      displayName: localeString.payment_methods_affirm,
      miniIcon: undefined
    },
    {
      paymentMethodName: "pay_safe_card",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "pay_safe_card"),
      displayName: localeString.payment_methods_pay_safe_card,
      miniIcon: undefined
    },
    {
      paymentMethodName: "crypto_currency",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "crypto"),
      displayName: localeString.payment_methods_crypto_currency,
      miniIcon: undefined
    },
    {
      paymentMethodName: "card",
      fields: [],
      icon: icon(19, undefined, "default-card"),
      displayName: localeString.payment_methods_card,
      miniIcon: undefined
    },
    {
      paymentMethodName: "klarna",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "klarna"),
      displayName: localeString.payment_methods_klarna,
      miniIcon: undefined
    },
    {
      paymentMethodName: "sofort",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "sofort"),
      displayName: localeString.payment_methods_sofort,
      miniIcon: undefined
    },
    {
      paymentMethodName: "flexiti",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "flexiti"),
      displayName: "Flixiti",
      miniIcon: undefined
    },
    {
      paymentMethodName: "breadpay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "breadpay"),
      displayName: "Breadpay",
      miniIcon: undefined
    },
    {
      paymentMethodName: "ach_transfer",
      fields: [],
      icon: icon(19, undefined, "ach"),
      displayName: localeString.payment_methods_ach_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "bacs_transfer",
      fields: [],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_bacs_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "sepa_bank_transfer",
      fields: [],
      icon: icon(19, undefined, "sepa"),
      displayName: localeString.payment_methods_sepa_bank_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "instant_bank_transfer",
      fields: [],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_instant_bank_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "instant_bank_transfer_finland",
      fields: [],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_instant_bank_transfer_finland,
      miniIcon: undefined
    },
    {
      paymentMethodName: "instant_bank_transfer_poland",
      fields: [],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_instant_bank_transfer_poland,
      miniIcon: undefined
    },
    {
      paymentMethodName: "sepa_debit",
      fields: [],
      icon: icon(19, 25, "sepa"),
      displayName: localeString.payment_methods_sepa_debit,
      miniIcon: undefined
    },
    {
      paymentMethodName: "giropay",
      fields: ["InfoElement"],
      icon: icon(19, 25, "giropay"),
      displayName: localeString.payment_methods_giropay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "eps",
      fields: ["InfoElement"],
      icon: icon(19, 25, "eps"),
      displayName: localeString.payment_methods_eps,
      miniIcon: undefined
    },
    {
      paymentMethodName: "walley",
      fields: ["InfoElement"],
      icon: icon(19, 25, "walley"),
      displayName: localeString.payment_methods_walley,
      miniIcon: undefined
    },
    {
      paymentMethodName: "pay_bright",
      fields: ["InfoElement"],
      icon: icon(19, 25, "paybright"),
      displayName: localeString.payment_methods_pay_bright,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ach_debit",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "ach"),
      displayName: localeString.payment_methods_ach_debit,
      miniIcon: undefined
    },
    {
      paymentMethodName: "bacs_debit",
      fields: ["InfoElement"],
      icon: icon(21, undefined, "bank"),
      displayName: localeString.payment_methods_bacs_debit,
      miniIcon: icon(19, undefined, "bank")
    },
    {
      paymentMethodName: "becs_debit",
      fields: ["InfoElement"],
      icon: icon(21, undefined, "bank"),
      displayName: localeString.payment_methods_becs_debit,
      miniIcon: icon(19, undefined, "bank")
    },
    {
      paymentMethodName: "blik",
      fields: ["InfoElement"],
      icon: icon(19, 25, "blik"),
      displayName: localeString.payment_methods_blik,
      miniIcon: undefined
    },
    {
      paymentMethodName: "trustly",
      fields: ["InfoElement"],
      icon: icon(19, 25, "trustly"),
      displayName: localeString.payment_methods_trustly,
      miniIcon: undefined
    },
    {
      paymentMethodName: "bancontact_card",
      fields: ["InfoElement"],
      icon: icon(19, 25, "bancontact"),
      displayName: localeString.payment_methods_bancontact_card,
      miniIcon: undefined
    },
    {
      paymentMethodName: "online_banking_czech_republic",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, 25, "bank"),
      displayName: localeString.payment_methods_online_banking_czech_republic,
      miniIcon: undefined
    },
    {
      paymentMethodName: "online_banking_slovakia",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, 25, "bank"),
      displayName: localeString.payment_methods_online_banking_slovakia,
      miniIcon: undefined
    },
    {
      paymentMethodName: "online_banking_finland",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, 25, "bank"),
      displayName: localeString.payment_methods_online_banking_finland,
      miniIcon: undefined
    },
    {
      paymentMethodName: "online_banking_poland",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, 25, "bank"),
      displayName: localeString.payment_methods_online_banking_poland,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ideal",
      fields: ["InfoElement"],
      icon: icon(19, 25, "ideal_wero"),
      displayName: localeString.payment_methods_ideal,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ban_connect",
      fields: [],
      icon: undefined,
      displayName: localeString.payment_methods_ban_connect,
      miniIcon: undefined
    },
    {
      paymentMethodName: "ach_bank_debit",
      fields: [],
      icon: icon(19, 25, "ach-bank-debit"),
      displayName: localeString.payment_methods_ach_bank_debit,
      miniIcon: undefined
    },
    {
      paymentMethodName: "przelewy24",
      fields: [
        "Email",
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, undefined, "p24"),
      displayName: localeString.payment_methods_przelewy24,
      miniIcon: undefined
    },
    {
      paymentMethodName: "interac",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "interac"),
      displayName: localeString.payment_methods_interac,
      miniIcon: undefined
    },
    {
      paymentMethodName: "twint",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "twint"),
      displayName: localeString.payment_methods_twint,
      miniIcon: undefined
    },
    {
      paymentMethodName: "vipps",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "vipps"),
      displayName: localeString.payment_methods_vipps,
      miniIcon: undefined
    },
    {
      paymentMethodName: "dana",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "dana"),
      displayName: localeString.payment_methods_dana,
      miniIcon: undefined
    },
    {
      paymentMethodName: "go_pay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "go_pay"),
      displayName: localeString.payment_methods_go_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "kakao_pay",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "kakao_pay"),
      displayName: localeString.payment_methods_kakao_pay,
      miniIcon: undefined
    },
    {
      paymentMethodName: "gcash",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "gcash"),
      displayName: localeString.payment_methods_gcash,
      miniIcon: undefined
    },
    {
      paymentMethodName: "momo",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "momo"),
      displayName: localeString.payment_methods_momo,
      miniIcon: undefined
    },
    {
      paymentMethodName: "touch_n_go",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "touch_n_go"),
      displayName: localeString.payment_methods_touch_n_go,
      miniIcon: undefined
    },
    {
      paymentMethodName: "bizum",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bizum"),
      displayName: localeString.payment_methods_bizum,
      miniIcon: undefined
    },
    {
      paymentMethodName: "classic",
      fields: ["InfoElement"],
      icon: icon(19, 50, "cash_voucher"),
      displayName: localeString.payment_methods_classic,
      miniIcon: icon(19, undefined, "cash_voucher")
    },
    {
      paymentMethodName: "online_banking_fpx",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, undefined, "online_banking_fpx"),
      displayName: localeString.payment_methods_online_banking_fpx,
      miniIcon: undefined
    },
    {
      paymentMethodName: "online_banking_thailand",
      fields: [
        "Bank",
        "InfoElement"
      ],
      icon: icon(19, undefined, "online_banking_thailand"),
      displayName: localeString.payment_methods_online_banking_thailand,
      miniIcon: undefined
    },
    {
      paymentMethodName: "alma",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "alma"),
      displayName: localeString.payment_methods_alma,
      miniIcon: undefined
    },
    {
      paymentMethodName: "atome",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "atome"),
      displayName: localeString.payment_methods_atome,
      miniIcon: undefined
    },
    {
      paymentMethodName: "multibanco_transfer",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "multibanco"),
      displayName: localeString.payment_methods_multibanco_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "card_redirect",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "default-card"),
      displayName: localeString.payment_methods_card_redirect,
      miniIcon: undefined
    },
    {
      paymentMethodName: "open_banking_uk",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_pay_by_bank,
      miniIcon: icon(19, undefined, "bank")
    },
    {
      paymentMethodName: "open_banking_pis",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_open_banking_pis,
      miniIcon: icon(19, undefined, "bank")
    },
    {
      paymentMethodName: "evoucher",
      fields: ["InfoElement"],
      icon: icon(19, 50, "cash_voucher"),
      displayName: localeString.payment_methods_evoucher,
      miniIcon: icon(19, undefined, "cash_voucher")
    },
    {
      paymentMethodName: "pix_transfer",
      fields: ["InfoElement"],
      icon: icon(26, 40, "pix"),
      displayName: localeString.payment_methods_pix_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "pix_emv_transfer",
      fields: ["InfoElement"],
      icon: icon(26, 40, "pix"),
      displayName: localeString.payment_methods_pix_emv_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "boleto",
      fields: ["InfoElement"],
      icon: icon(21, 25, "boleto"),
      displayName: localeString.payment_methods_boleto,
      miniIcon: undefined
    },
    {
      paymentMethodName: "paypal",
      fields: ["InfoElement"],
      icon: icon(21, 25, "paypal"),
      displayName: localeString.payment_methods_paypal,
      miniIcon: undefined
    },
    {
      paymentMethodName: "local_bank_transfer_transfer",
      fields: ["InfoElement"],
      icon: icon(19, 30, "union-pay"),
      displayName: localeString.payment_methods_local_bank_transfer_transfer,
      miniIcon: undefined
    },
    {
      paymentMethodName: "mifinity",
      fields: ["InfoElement"],
      icon: icon(undefined, undefined, "mifinity"),
      displayName: localeString.payment_methods_mifinity,
      miniIcon: undefined
    },
    {
      paymentMethodName: "skrill",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "skrill"),
      displayName: "Skrill",
      miniIcon: undefined
    },
    {
      paymentMethodName: "bluecode",
      fields: ["InfoElement"],
      icon: icon(undefined, undefined, "bluecode"),
      displayName: "Bluecode",
      miniIcon: undefined
    },
    {
      paymentMethodName: "upi_collect",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bhim_upi"),
      displayName: localeString.payment_methods_upi_collect,
      miniIcon: undefined
    },
    {
      paymentMethodName: "upi_intent",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bhim_upi"),
      displayName: "UPI Intent",
      miniIcon: undefined
    },
    {
      paymentMethodName: "eft",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "eft"),
      displayName: localeString.payment_methods_eft,
      miniIcon: undefined
    },
    {
      paymentMethodName: "givex",
      fields: ["InfoElement"],
      icon: icon(19, 25, "givex"),
      displayName: localeString.payment_methods_givex,
      miniIcon: undefined
    },
    {
      paymentMethodName: "open_banking",
      fields: ["InfoElement"],
      icon: icon(19, undefined, "bank"),
      displayName: localeString.payment_methods_pay_by_bank,
      miniIcon: icon(19, undefined, "bank")
    },
    {
      paymentMethodName: "saved_methods",
      fields: [],
      icon: icon(19, undefined, "default-card"),
      displayName: localeString.payment_methods_saved_methods,
      miniIcon: undefined
    }
  ];
}

function getPaymentMethodsFieldTypeFromString(str, isBancontact) {
  switch (str) {
    case "user_address_city" :
      return "AddressCity";
    case "user_address_line1" :
      return "AddressLine1";
    case "user_address_line2" :
      return "AddressLine2";
    case "user_address_pincode" :
      return "AddressPincode";
    case "user_address_state" :
      return "AddressState";
    case "user_bank" :
      return "Bank";
    case "user_billing_name" :
      return "BillingName";
    case "user_blik_code" :
      return "BlikCode";
    case "user_card_cvc" :
      if (isBancontact) {
        return "CardCvc";
      } else {
        return "None";
      }
    case "user_card_expiry_month" :
      if (isBancontact) {
        return "CardExpiryMonth";
      } else {
        return "None";
      }
    case "user_card_expiry_year" :
      if (isBancontact) {
        return "CardExpiryYear";
      } else {
        return "None";
      }
    case "user_card_number" :
      if (isBancontact) {
        return "CardNumber";
      } else {
        return "None";
      }
    case "user_cnpj" :
      return "PixCNPJ";
    case "user_country" :
      return "Country";
    case "user_cpf" :
      return "PixCPF";
    case "user_crypto_currency_network" :
      return "CryptoCurrencyNetworks";
    case "user_date_of_birth" :
      return "DateOfBirth";
    case "user_email_address" :
      return "Email";
    case "user_full_name" :
      return "FullName";
    case "user_gift_card_number" :
      return "GiftCardNumber";
    case "user_gift_card_pin" :
      return "GiftCardPin";
    case "user_bank_account_number" :
    case "user_iban" :
      return "BankAccountNumber";
    case "user_phone_number" :
      return "PhoneNumber";
    case "user_phone_number_country_code" :
      return "PhoneCountryCode";
    case "user_pix_key" :
      return "PixKey";
    case "user_shipping_address_city" :
      return "ShippingAddressCity";
    case "user_shipping_address_line1" :
      return "ShippingAddressLine1";
    case "user_shipping_address_line2" :
      return "ShippingAddressLine2";
    case "user_shipping_address_pincode" :
      return "ShippingAddressPincode";
    case "user_shipping_address_state" :
      return "ShippingAddressState";
    case "user_shipping_name" :
      return "ShippingName";
    case "user_social_security_number" :
      return "DocumentNumber";
    case "user_source_bank_account_id" :
      return "SourceBankAccountId";
    case "user_vpa_id" :
      return "VpaId";
    default:
      return "None";
  }
}

let countryData = CountryStateDataRefs$OrcaPaymentPage.countryDataRef.contents;

function getOptionsFromPaymentMethodFieldType(dict, key, isAddressCountryOpt) {
  let isAddressCountry = isAddressCountryOpt !== undefined ? isAddressCountryOpt : true;
  let options = Utils$OrcaPaymentPage.getArrayValFromJsonDict(dict, key, "options");
  let match = Core__Option.getOr(options[0], "");
  switch (match) {
    case "" :
      return "None";
    case "ALL" :
      let countryArr = countryData.map(item => item.countryName);
      if (isAddressCountry) {
        return {
          TAG: "AddressCountry",
          _0: countryArr
        };
      } else {
        return {
          TAG: "ShippingAddressCountry",
          _0: countryArr
        };
      }
    default:
      let countryArr$1 = Core__Array.reduce(countryData, [], (acc, country) => {
        if (options.includes(country.isoAlpha2)) {
          acc.push(country.countryName);
        }
        return acc;
      });
      if (isAddressCountry) {
        return {
          TAG: "AddressCountry",
          _0: countryArr$1
        };
      } else {
        return {
          TAG: "ShippingAddressCountry",
          _0: countryArr$1
        };
      }
  }
}

function getPaymentMethodsFieldTypeFromDict(dict) {
  let keysArr = Object.keys(dict);
  let key = Core__Option.getOr(keysArr[0], "");
  switch (key) {
    case "language_preference" :
      let options = Utils$OrcaPaymentPage.getArrayValFromJsonDict(dict, "language_preference", "options");
      return {
        TAG: "LanguagePreference",
        _0: options
      };
    case "user_address_country" :
      return getOptionsFromPaymentMethodFieldType(dict, "user_address_country", undefined);
    case "user_bank_options" :
      let options$1 = Utils$OrcaPaymentPage.getArrayValFromJsonDict(dict, "user_bank_options", "options");
      return {
        TAG: "BankList",
        _0: options$1
      };
    case "user_country" :
      return getOptionsFromPaymentMethodFieldType(dict, "user_country", undefined);
    case "user_currency" :
      let options$2 = Utils$OrcaPaymentPage.getArrayValFromJsonDict(dict, "user_currency", "options");
      return {
        TAG: "Currency",
        _0: options$2
      };
    case "user_document_type" :
      let options$3 = Utils$OrcaPaymentPage.getArrayValFromJsonDict(dict, "user_document_type", "options");
      return {
        TAG: "DocumentType",
        _0: options$3
      };
    case "user_shipping_address_country" :
      return getOptionsFromPaymentMethodFieldType(dict, "user_shipping_address_country", false);
    default:
      return "None";
  }
}

function getFieldType(dict, isBancontact) {
  let fieldClass = Core__JSON.Classify.classify(Core__Option.getOr(dict["field_type"], {}));
  if (typeof fieldClass !== "object") {
    return "None";
  }
  switch (fieldClass.TAG) {
    case "String" :
      return getPaymentMethodsFieldTypeFromString(fieldClass._0, isBancontact);
    case "Object" :
      return getPaymentMethodsFieldTypeFromDict(fieldClass._0);
    case "Bool" :
    case "Number" :
    case "Array" :
      return "None";
  }
}

function getPaymentDetails(arr, localeString) {
  let finalArr = [];
  let paymentMethodsFields = getPaymentMethodsFields(localeString);
  arr.map(item => {
    let optionalVal = paymentMethodsFields.find(i => i.paymentMethodName === item);
    if (optionalVal !== undefined) {
      finalArr.push(optionalVal);
      return;
    }
  });
  return finalArr;
}

let defaultCardNetworks_eligible_connectors = [];

let defaultCardNetworks = {
  card_network: "NOTFOUND",
  eligible_connectors: defaultCardNetworks_eligible_connectors,
  surcharge_details: undefined
};

let defaultMethods_payment_method_types = [];

let defaultMethods = {
  payment_method: "card",
  payment_method_types: defaultMethods_payment_method_types
};

let defaultPaymentMethodType_payment_experience = [];

let defaultPaymentMethodType_card_networks = [];

let defaultPaymentMethodType_bank_names = [];

let defaultPaymentMethodType_bank_debits_connectors = [];

let defaultPaymentMethodType_bank_transfers_connectors = [];

let defaultPaymentMethodType = {
  payment_method_type: "",
  payment_experience: defaultPaymentMethodType_payment_experience,
  card_networks: defaultPaymentMethodType_card_networks,
  bank_names: defaultPaymentMethodType_bank_names,
  bank_debits_connectors: defaultPaymentMethodType_bank_debits_connectors,
  bank_transfers_connectors: defaultPaymentMethodType_bank_transfers_connectors,
  surcharge_details: undefined,
  pm_auth_connector: undefined,
  customer_acceptance_support: undefined
};

let defaultIntentData_intentDataObject = null;

let defaultIntentData = {
  installment_options: undefined,
  currency: "",
  intentDataObject: defaultIntentData_intentDataObject
};

let defaultList_payment_methods = [];

let defaultList = {
  redirect_url: "",
  currency: "",
  payment_methods: defaultList_payment_methods,
  mandate_payment: undefined,
  payment_type: "NONE",
  merchant_name: "",
  is_tax_calculation_enabled: false,
  isGuestCustomer: undefined,
  intent_data: defaultIntentData,
  sdk_next_action: undefined,
  should_block_confirm: false
};

function getPaymentExperienceType(str) {
  switch (str) {
    case "display_qr_code" :
      return "QrFlow";
    case "invoke_sdk_client" :
      return "InvokeSDK";
    default:
      return "RedirectToURL";
  }
}

function getSurchargeDetails(dict) {
  let surchargDetails = Core__Option.getOr(Core__Option.flatMap(dict["surcharge_details"], Core__JSON.Decode.object), {});
  let displayTotalSurchargeAmount = Core__Option.getOr(Core__Option.flatMap(surchargDetails["display_total_surcharge_amount"], Core__JSON.Decode.float), 0.0);
  if (displayTotalSurchargeAmount !== 0.0) {
    return {
      displayTotalSurchargeAmount: displayTotalSurchargeAmount
    };
  }
}

function getAmountDetails(dict) {
  return {
    amount_per_installment: Utils$OrcaPaymentPage.getFloat(dict, "amount_per_installment", 0.0),
    total_amount: Utils$OrcaPaymentPage.getFloat(dict, "total_amount", 0.0)
  };
}

function getInstallmentPlan(dict) {
  return {
    interest_rate: Utils$OrcaPaymentPage.getFloat(dict, "interest_rate", 0.0),
    number_of_installments: Utils$OrcaPaymentPage.getInt(dict, "number_of_installments", 0),
    billing_frequency: Utils$OrcaPaymentPage.getString(dict, "billing_frequency", ""),
    amount_details: getAmountDetails(Utils$OrcaPaymentPage.getDictFromDict(dict, "amount_details"))
  };
}

function getInstallmentOptions(dict) {
  let installmentOptions = Utils$OrcaPaymentPage.getArray(dict, "installment_options");
  if (installmentOptions.length > 0) {
    return Core__Array.filterMap(installmentOptions, Core__JSON.Decode.object).map(json => ({
      payment_method: Utils$OrcaPaymentPage.getString(json, "payment_method", ""),
      available_plans: Utils$OrcaPaymentPage.getArrayOfObjectsFromDict(json, "available_plans").map(getInstallmentPlan)
    }));
  }
}

function getOptionalMandateType(dict, str) {
  return Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), json => ({
    amount: Utils$OrcaPaymentPage.getInt(json, "amount", 0),
    currency: Utils$OrcaPaymentPage.getString(json, "currency", "")
  }));
}

function getMandate(dict, str) {
  return Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), json => ({
    single_use: getOptionalMandateType(json, "single_use"),
    multi_use: getOptionalMandateType(json, "multi_use")
  }));
}

function getIntentData(dict) {
  let intentDataDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "intent_data");
  return {
    installment_options: getInstallmentOptions(intentDataDict),
    currency: Utils$OrcaPaymentPage.getString(intentDataDict, "currency", ""),
    intentDataObject: intentDataDict
  };
}

function paymentTypeMapper(payment_type) {
  switch (payment_type) {
    case "new_mandate" :
      return "NEW_MANDATE";
    case "normal" :
      return "NORMAL";
    case "setup_mandate" :
      return "SETUP_MANDATE";
    default:
      return "NONE";
  }
}

function paymentTypeToStringMapper(payment_type) {
  switch (payment_type) {
    case "NORMAL" :
      return "normal";
    case "NEW_MANDATE" :
      return "new_mandate";
    case "SETUP_MANDATE" :
      return "setup_mandate";
    case "NONE" :
      return "";
  }
}

function getCardNetworksFromFlatList(jsonDict, str) {
  return Utils$OrcaPaymentPage.getStrArray(jsonDict, str).map(cardNetworkStr => ({
    card_network: CardUtils$OrcaPaymentPage.getCardType(cardNetworkStr),
    eligible_connectors: [],
    surcharge_details: undefined
  }));
}

function getPaymentExperienceFromFlatList(jsonDict, str) {
  return Utils$OrcaPaymentPage.getStrArray(jsonDict, str).map(experienceStr => ({
    payment_experience_type: getPaymentExperienceType(experienceStr),
    eligible_connectors: []
  }));
}

function getPaymentMethodTypesFromFlatList(paymentMethodsEnabled) {
  let methodsDict = {};
  Belt_Array.keepMap(paymentMethodsEnabled, Core__JSON.Decode.object).forEach(jsonDict => {
    let paymentMethod = Utils$OrcaPaymentPage.getString(jsonDict, "payment_method", "");
    let paymentMethodType = Utils$OrcaPaymentPage.getString(jsonDict, "payment_method_type", "");
    let paymentMethodTypeRecord_payment_experience = getPaymentExperienceFromFlatList(jsonDict, "payment_experience");
    let paymentMethodTypeRecord_card_networks = getCardNetworksFromFlatList(jsonDict, "card_networks");
    let paymentMethodTypeRecord_bank_names = [];
    let paymentMethodTypeRecord_bank_debits_connectors = [];
    let paymentMethodTypeRecord_bank_transfers_connectors = [];
    let paymentMethodTypeRecord_surcharge_details = getSurchargeDetails(jsonDict);
    let paymentMethodTypeRecord_pm_auth_connector = Utils$OrcaPaymentPage.getOptionString(jsonDict, "pm_auth_connector");
    let paymentMethodTypeRecord_customer_acceptance_support = getCustomerAcceptanceSupport(jsonDict, "customer_acceptance_support");
    let paymentMethodTypeRecord = {
      payment_method_type: paymentMethodType,
      payment_experience: paymentMethodTypeRecord_payment_experience,
      card_networks: paymentMethodTypeRecord_card_networks,
      bank_names: paymentMethodTypeRecord_bank_names,
      bank_debits_connectors: paymentMethodTypeRecord_bank_debits_connectors,
      bank_transfers_connectors: paymentMethodTypeRecord_bank_transfers_connectors,
      surcharge_details: paymentMethodTypeRecord_surcharge_details,
      pm_auth_connector: paymentMethodTypeRecord_pm_auth_connector,
      customer_acceptance_support: paymentMethodTypeRecord_customer_acceptance_support
    };
    let existingTypes = methodsDict[paymentMethod];
    if (existingTypes !== undefined) {
      methodsDict[paymentMethod] = existingTypes.concat([paymentMethodTypeRecord]);
    } else {
      methodsDict[paymentMethod] = [paymentMethodTypeRecord];
    }
  });
  return Object.entries(methodsDict).map(param => ({
    payment_method: param[0],
    payment_method_types: param[1]
  }));
}

function itemToObjMapperFromClientList(dict) {
  let intentDataDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "intent_data");
  return {
    redirect_url: "",
    currency: Utils$OrcaPaymentPage.getString(intentDataDict, "currency", ""),
    payment_methods: getPaymentMethodTypesFromFlatList(Utils$OrcaPaymentPage.getArray(dict, "payment_methods_enabled")),
    mandate_payment: getMandate(intentDataDict, "mandate_payment"),
    payment_type: paymentTypeMapper(Utils$OrcaPaymentPage.getString(intentDataDict, "payment_type", "")),
    merchant_name: Utils$OrcaPaymentPage.getString(intentDataDict, "merchant_name", ""),
    is_tax_calculation_enabled: Utils$OrcaPaymentPage.getBool(intentDataDict, "is_tax_calculation_enabled", false),
    isGuestCustomer: Utils$OrcaPaymentPage.getOptionBool(intentDataDict, "is_guest_customer"),
    intent_data: getIntentData(dict),
    sdk_next_action: Utils$OrcaPaymentPage.getOptionString(Utils$OrcaPaymentPage.getDictFromDict(dict, "sdk_next_action"), "next_action"),
    should_block_confirm: Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getDictFromDict(dict, "sdk_next_action"), "should_block_confirm", false)
  };
}

function buildFromPaymentList(pList) {
  let paymentMethodArr = pList.payment_methods;
  return Core__Array.reduce(paymentMethodArr.map(paymentMethodObject => {
    let methodType = paymentMethodObject.payment_method;
    let handleUserError = methodType === "wallet";
    return paymentMethodObject.payment_method_types.map(individualPaymentMethod => {
      let paymentMethodName = individualPaymentMethod.payment_method_type;
      let bankNames = individualPaymentMethod.bank_names;
      let paymentExperience = individualPaymentMethod.payment_experience.map(experience => [
        experience.payment_experience_type,
        experience.eligible_connectors
      ]);
      return {
        paymentMethodName: paymentMethodName,
        paymentFlow: paymentExperience,
        handleUserError: handleUserError,
        methodType: methodType,
        bankNames: bankNames,
        customerAcceptanceSupport: individualPaymentMethod.customer_acceptance_support
      };
    });
  }), [], (acc, item) => {
    item.forEach(obj => {
      acc.push(obj);
    });
    return acc;
  });
}

function getPaymentMethodTypeFromList(paymentMethodListValue, paymentMethod, paymentMethodType) {
  return Core__Option.getOr(paymentMethodListValue.payment_methods.find(item => item.payment_method === paymentMethod), defaultMethods).payment_method_types.find(item => item.payment_method_type === paymentMethodType);
}

function getCardNetwork(paymentMethodType, cardBrand) {
  return Core__Option.getOr(paymentMethodType.card_networks.filter(cardNetwork => cardNetwork.card_network === cardBrand)[0], defaultCardNetworks);
}

function getPaymentExperienceTypeFromPML(paymentMethodList, paymentMethodName, paymentMethodType) {
  return Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(paymentMethodList.payment_methods.filter(paymentMethod => paymentMethod.payment_method === paymentMethodName)[0], method => method.payment_method_types.filter(methodTypes => methodTypes.payment_method_type === paymentMethodType)[0]), paymentMethodTypes => paymentMethodTypes.payment_experience.map(paymentExperience => paymentExperience.payment_experience_type)), []);
}

export {
  getPaymentMethodsFieldsOrder,
  sortPaymentMethodFields,
  getCustomerAcceptanceSupport,
  defaultPaymentFieldsInfo,
  defaultPaymentMethodContent,
  defaultPaymentMethodFields,
  icon,
  getPaymentMethodsFields,
  getPaymentMethodsFieldTypeFromString,
  countryData,
  getOptionsFromPaymentMethodFieldType,
  getPaymentMethodsFieldTypeFromDict,
  getFieldType,
  getPaymentDetails,
  defaultCardNetworks,
  defaultMethods,
  defaultPaymentMethodType,
  defaultIntentData,
  defaultList,
  getPaymentExperienceType,
  getSurchargeDetails,
  getAmountDetails,
  getInstallmentPlan,
  getInstallmentOptions,
  getOptionalMandateType,
  getMandate,
  getIntentData,
  paymentTypeMapper,
  paymentTypeToStringMapper,
  getCardNetworksFromFlatList,
  getPaymentExperienceFromFlatList,
  getPaymentMethodTypesFromFlatList,
  itemToObjMapperFromClientList,
  buildFromPaymentList,
  getPaymentMethodTypeFromList,
  getCardNetwork,
  getPaymentExperienceTypeFromPML,
}
/* react/jsx-runtime Not a pure module */
